(ns ui.view.entity-creator.opportunity.model)

(def root ::state)
(def root-path [root])

;; Multiple simultaneous creator-modals allowed
;; => each instance must have an identity.
;; In this case
;; identity will be a vector that, combined with
;; the root key above denotes the path where in the rf-state
;; the modal instance related state will be located
(defn i-root
  [ident]
  {:pre [(vector? ident)]}
  (into root-path ident))

(def processing-key :processing)
(def processing-path [processing-key])
(defn processing-full-path
  [ident]
  (into (i-root ident) processing-path))

(def processing-start-time-key :processing-start-time)
(def processing-start-time-path [processing-start-time-key])
(defn processing-start-time-full-path
  [ident]
  (into (i-root ident) processing-start-time-path))

(def created-entity-key :created-entity)
(def created-entity-path [created-entity-key])
(defn created-entity-full-path
  [ident]
  (into (i-root ident) created-entity-path))

(def callbacks-key :callbacks)
(def callbacks-path [callbacks-key])
(defn callbacks-full-path
  [ident]
  (into (i-root ident) callbacks-path))

(def pipeline-key :pipeline)
(def pipeline-path [pipeline-key])
(defn pipeline-full-path
  [ident]
  (into (i-root ident) pipeline-path))

(def entity-type-key :entity-type)
(def entity-type-path [entity-type-key])
(defn entity-type-full-path
  [ident]
  (into (i-root ident) entity-type-path))

(def stage-key :stage)
(def stage-path [stage-key])
(defn stage-full-path
  [ident]
  (into (i-root ident) stage-path))

(def selected-target-key :selected-target)
(def selected-target-path [selected-target-key])
(defn selected-target-full-path
  [ident]
  (into (i-root ident) selected-target-path))

(def target-profile-key :target-profile)
(def target-profile-path [target-profile-key])
(defn target-profile-full-path
  [ident]
  (into (i-root ident) target-profile-path))

(def creator-previous-target-key :creator-previous-target)
(def creator-previous-target-path [creator-previous-target-key])
(defn creator-previous-target-full-path
  [ident]
  (into (i-root ident) creator-previous-target-path))

(def creator-previous-target-profile-key :creator-previous-target-profile)
(def creator-previous-target-profile-path [creator-previous-target-profile-key])
(defn creator-previous-target-profile-full-path
  [ident]
  (into (i-root ident) creator-previous-target-profile-path))

(def associations-target-type-key :associations-target-type)
(def associations-target-type-path [associations-target-type-key])
(defn associations-target-type-full-path
  [ident]
  (into (i-root ident) associations-target-type-path))

(def target-creator-type-key :target-creator-type)
(def target-creator-type-path [target-creator-type-key])
(defn target-creator-type-full-path
  [ident]
  (into (i-root ident) target-creator-type-path))

(def current-view-key :current-view)
(def current-view-path [current-view-key])
(defn current-view-full-path
  [ident]
  (into (i-root ident) current-view-path))

(def initial-target-value-key :initial-target-value)
(def initial-target-value-path [initial-target-value-key])
(defn initial-target-value-full-path
  [ident]
  (into (i-root ident) initial-target-value-path))

(def target-locked?-key :target-locked?)
(def target-locked?-path [target-locked?-key])
(defn target-locked?-full-path
  [ident]
  (into (i-root ident) target-locked?-path))

(def open-entity-fn-key :open-entity-fn)
(def open-entity-fn-path [open-entity-fn-key])
(defn open-entity-fn-full-path
  [ident]
  (into (i-root ident) open-entity-fn-path))

(def associations-edits-key :associations-edits)
(def associations-edits-path [associations-edits-key])
(defn associations-edits-full-path
  [ident]
  (into (i-root ident) associations-edits-path))

(def current-association-prefills-key :current-association-prefills)
(def current-association-prefills-path [current-association-prefills-key])
(defn current-association-prefills-full-path
  [ident]
  (into (i-root ident) current-association-prefills-path))

;; custom :on-ok! to pass for nested-creator
(def nested-on-ok-key :nested-on-ok)
(def nested-on-ok-path [nested-on-ok-key])
(defn nested-on-ok-full-path
  [ident]
  (into (i-root ident) nested-on-ok-path))

;;; Subscriptions:
(def root-state ::root-state)
(def state ::state)

(def pipeline ::pipeline)
(def pipeline-id ::pipeline-id)
(def stages ::stages)
(def stage ::stage)
(def stage-id ::stage-id)
(def target-query ::target-query)
(def selected-target ::selected-target)
(def target-profile ::target-profile)
(def entity-type ::entity-type)
(def target-type ::target-type)
(def target-creator-type ::target-creator-type)
(def creator-previous-target ::creator-previous-target)
(def creator-previous-target-profile ::creator-previous-target-profile)
(def associations-target-type ::associations-target-type)
(def current-view ::current-view)
(def initial-target-value ::initial-target-value)
(def target-locked? ::target-locked?)
(def open-entity-fn ::open-entity-fn)
(def associations-edits ::associations-edits)
(def associations-config ::associations-config)
(def main-entity-config ::main-entity-config)
(def nested-on-ok ::nested-on-ok)

(def processing? ::processing?)

(def subview ::subview)

;;; Events:
(def initialize ::initialize)
(def close-creator ::close-creator)
(def select-target ::select-target)
(def confirm-target ::confirm-target)
(def target-load-failed ::target-load-failed)
(def confirm-entity ::confirm-entity)
(def confirm-contact-details ::confirm-contact-details)
(def navigate-back ::navigate-back)
(def set-association ::set-association)
(def reset-associations ::reset-associations)
(def set-creator-previous-target ::set-creator-previous-target)
(def set-creator-previous-target-profile ::set-creator-previous-target-profile)
(def set-associations-target-type ::set-associations-target-type)
(def set-nested-creator ::set-nested-creator)
(def start-create ::start-create)
(def create-error ::create-error)
(def create-success ::create-success)
(def processing-done ::processing-done)
(def finish ::finish)

;;; Effects
(def callback-fx ::callback-fx)

;;; Coeffects
(def selected-target-entity-cofx ::selected-target-entity-cofx)
(def associations-config-cofx ::associations-config-cofx)
(def target-profile-cofx ::target-profile-cofx)

;;; helpers
(defn resolve-creator-ident
  [{:keys [ident]}]
  (into ident [:nested :main-entity]))

(defn resolve-target-creator-ident
  [{:keys [ident]}]
  (into ident [:nested :target-entity]))

(defn resolve-target-profile-creator-ident
  [{:keys [ident]}]
  (into ident [:nested :target-profile-entity]))

(defn resolve-nested-creator-ident
  [{:keys [ident]}]
  (into ident [:nested :association-creator]))
